export var addAccountMapper = function (response) {
    if (response) {
        return {
            status: true,
            message: response.msg,
        };
    }
    return {
        status: false,
        message: "Unable to register",
    };
};
